import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService as Auth0AuthService } from '@auth0/auth0-angular';
import { AUTH_LOGIN_ROUTE } from 'app/core/constants';
import { BrandingService } from 'app/core/services/branding.service';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizeGuard {
  constructor(
    private authService: AuthService,
    private auth0AuthService: Auth0AuthService,
    private brandingService: BrandingService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // TODO: figure out how to handle this in routing
    if (state.url.includes('enroll/expired')) {
      return true;
    }

    if (this.brandingService.authConfig.useAuth0) {
      const queryParams = route.queryParams;

      // TODO: MVP Handle Auth0 invitation links
      // If the user is invited to an organization, redirect to Auth0 login with the invitation and organization parameters
      // if (queryParams.invitation && queryParams.organization) {
      //   const scopes = 'openid profile email offline_access';
      //   this.auth0AuthService.loginWithRedirect({
      //     appState: { target: `/${HOMEPAGE_ROUTE}` },
      //     authorizationParams: {
      //       useRefreshTokens: true,
      //       redirect_uri: `${window.location.origin}`,
      //       organization: queryParams.organization,
      //       invitation: queryParams.invitation,
      //       audience: this.brandingService.authConfig.audience,
      //       scope: scopes,
      //     },
      //   });
      //   return false;
      // }

      return this.auth0AuthService.isAuthenticated$.pipe(
        take(1),
        map((isAuthenticated) => {
          if (!isAuthenticated) {
            return this.router.createUrlTree(['/' + AUTH_LOGIN_ROUTE], {
              queryParams: { redirectTo: state.url },
            });
          }

          this.authService.handleExternalAuthentication();

          return true;
        }),
      );
    } else {
      if (this.authService.user || !AuthService.isTokenExpired() || !AuthService.isRefreshTokenExpired()) {
        return true;
      } else {
        // No one logged in or token is expired
        // Redirect to login
        return this.router.createUrlTree(['/' + AUTH_LOGIN_ROUTE], {
          queryParams: { redirectTo: state.url },
        });
      }
    }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // TODO: figure out how to handle this in routing
    if (state.url.includes('enroll/expired')) {
      return true;
    }

    if (this.brandingService.authConfig.useAuth0) {
      return this.auth0AuthService.isAuthenticated$.pipe(
        take(1),
        map((isAuthenticated) => {
          if (!isAuthenticated) {
            return this.router.createUrlTree(['/' + AUTH_LOGIN_ROUTE], {
              queryParams: { redirectTo: state.url },
            });
          }

          this.authService.handleExternalAuthentication();

          return true;
        }),
      );
    } else {
      if (this.authService.user || !AuthService.isTokenExpired() || !AuthService.isRefreshTokenExpired()) {
        return true;
      } else {
        // No one logged in or token is expired
        // Redirect to login
        return this.router.createUrlTree(['/' + AUTH_LOGIN_ROUTE], {
          queryParams: { redirectTo: state.url },
        });
      }
    }
  }
}
